import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { customizedScreenRoutes } from '@custom/custom.route';

@Component({
    selector: 'app-list-custmenubase',
    templateUrl: './list-custmenubase.component.html',
    styleUrls: ['./list-custmenubase.component.scss'],
})
export class ListCustMenuBaseComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public dataList = [];

    protected _isInRangeTimeout: any;

    public listColumns = [];
    public screenList = [];
    public screenBase = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'name' },
            { header: this.translate.instant('Col_Inti_1'), field: 'label' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getcustmenubaselist',''));
            this.dataList = wRes.data.data.map((item) => {
                item._label = item.label;
                return item;
            });
        for (const item of customizedScreenRoutes) {
            if (item.path !== '') {
                this.screenList.push({ label: item.path, value: item.path });
            }
        }
        this.screenBase = [...this.screenList];

        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.dataList = this.dataList.map((item) => {
            if (item.id === event.data.id) {
                item.label = event.data.label;
                item.name = event.data.name;
                item._label = event.data.label;
                return item;
            } else {
                return item;
            }
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    addTab(event) {
        this.dataList.push(event.data);
        this.dataList = [...this.dataList];
        this.dataList = this.dataList.map((item) => {
            item._label = item.name;
            return item;
        });
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    deleteTab(event) {
        this.dataList = this.dataList.filter((item) => {
            return item.id !== event.data.id;
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelCm', {label: event.data.name}),
            () => {
                this.delete(event);
            }
        );
    }
    
    public async delete(event) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletecustmenubase', event.data.id ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    sortReference(event: any): void {}
}
